import React from 'react';
import { IApiService } from '../../../store/services/api-service';

export const ApiContext = React.createContext<IApiService>({} as IApiService);
export default ApiContext;
